import React from 'react';
import { ACCENT_HEX } from '../../lib/juniorTheme';

interface TapPalmasButtonProps {
  onTap: () => void;
  disabled?: boolean;
  flash?: 'hit' | 'fault' | null;
  label?: string;
  emoji?: string;
}

export const TapPalmasButton: React.FC<TapPalmasButtonProps> = ({
  onTap,
  disabled = false,
  flash = null,
  label = 'Clap',
  emoji = '👏',
}) => {
  const hex = ACCENT_HEX.coral;
  const flashBg =
    flash === 'hit' ? '#10B981' : flash === 'fault' ? '#F472B6' : hex;

  return (
    <button
      type="button"
      onPointerDown={(e) => {
        e.preventDefault();
        if (!disabled) onTap();
      }}
      disabled={disabled}
      className="eco-tap-btn relative flex flex-col items-center justify-center rounded-full transition-transform active:scale-95 disabled:opacity-50 disabled:pointer-events-none"
      style={{
        width: 'clamp(120px, 28vw, 160px)',
        height: 'clamp(120px, 28vw, 160px)',
        background: `radial-gradient(circle at 35% 30%, #fff8 0%, ${flashBg} 45%, ${flashBg}dd 100%)`,
        boxShadow:
          flash === 'hit'
            ? '0 0 0 8px #10B98140, 0 20px 48px -8px #10B98190'
            : flash === 'fault'
              ? '0 0 0 8px #F472B640, 0 20px 48px -8px #F472B690'
              : `0 0 0 6px ${hex}30, 0 20px 48px -8px ${hex}80`,
        border: '4px solid rgba(255,255,255,0.85)',
      }}
      aria-label={`Tocar ${label}`}
    >
      <span className="text-5xl sm:text-6xl" aria-hidden>
        {emoji}
      </span>
      <span className="text-sm sm:text-base font-extrabold text-white mt-1 drop-shadow">{label}</span>
    </button>
  );
};

export default TapPalmasButton;
